// Polyfill lockdown MUST be the first import — its side effects pin
// window.Buffer / window.process / window.global before any React or
// Web3 module evaluates. config-overrides.js wires ProvidePlugin as
// a backup, but we force it here because Vercel's webpack pass has
// been flakier than the local dev server.
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { ThirdwebProvider } from '@thirdweb-dev/react';
import { ACTIVE_CHAIN, THIRDWEB_CLIENT_ID } from './global/thirdwebConfig';

// ThirdwebProvider wraps the entire router so hooks like useAddress /
// useConnect are available on any route. Ghost Mode pages never touch
// these hooks, so the provider is inert on the "/" / "/multi" paths —
// it simply registers the default chain (Base Sepolia) and hangs
// around in case the citizen navigates to /global.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThirdwebProvider activeChain={ACTIVE_CHAIN} clientId={THIRDWEB_CLIENT_ID}>
        <App />
      </ThirdwebProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
